import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {BreadcrumbService} from "./breadcrumb.service";
import {DomSanitizer} from "@angular/platform-browser";

export interface IBreadCrumb {
   label: string;
   url: string;
}

@Component({
   selector: 'app-breadcrumb',
   templateUrl: './breadcrumb.component.html',
   styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

   constructor(public breadcrumbSrv:BreadcrumbService,
               private sanitizer: DomSanitizer,
               public router:Router) {
   }

   ngOnInit(): void {

   }

   clickLink(url: string) {
      this.router.navigateByUrl(url)
   }

   public toHtml(html:any){
      return this.sanitizer.bypassSecurityTrustHtml(html);
   }
}
